<template>
  <nav
    class="jps-search-page-nav"
    role="navigation"
    :aria-label="lss('表示するページの指定', 'Set page')"
  >
    <form class="page-input" @submit.prevent="gotoInput()">
      <input class="jps-input" type="text" v-model="inputPage" />&nbsp;/
      <span class="is-size-7">
        &nbsp;{{ num(maxPage) }}&nbsp;
        {{ lss('ページ', ' page') }}
      </span>
    </form>
    <UiButtonIcon
      class="jps-pagination-button"
      @click="goto(page - 1)"
      :disabled="page <= 1"
      :arialabel="ls(dapLangGlobal.prev)"
      icon="mdi/arrow-left"
    />
    <UiButtonIcon
      class="jps-pagination-button"
      @click="goto(page + 1)"
      :disabled="page >= maxPage"
      :arialabel="ls(dapLangGlobal.next)"
      icon="mdi/arrow-right"
    />
  </nav>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'

const { ls, lss, num } = useI18n()

interface Props {
  ss: SearchStore<any>
}
const props = withDefaults(defineProps<Props>(), {
})

const innerPage = ref(0)

const goto = page => {
  if (page < 1) page = 1
  if (page > maxPage.value) page = maxPage.value
  props.ss.setFrom(props.ss.state.currentQuery.size * (page - 1))
}

const inputPage = computed({
  get: () => {
    return page.value
  },
  set: n => {
    let str = String(n) || '1'
    str = zenkaku2Hankaku(str)
    str = str.replace(/[^0-9]/g, '')
    innerPage.value = Number(str)
  },
})

const gotoInput = () => {
  if (!innerPage.value) innerPage.value = 1
  if (innerPage.value > page.value + 100) innerPage.value = page.value + 100
  goto(innerPage.value)
}

const page = computed(() => {
  return (
    Math.floor(
      props.ss.state.currentQuery.from / props.ss.state.currentQuery.size,
    ) + 1
  )
})

const maxPage = computed(() => {
  return Math.ceil(props.ss.state.result.hit / props.ss.state.currentQuery.size)
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-search-page-nav {
  display: flex;
  align-items: center;
  .jps-pagination-button {
    display: block;
    text-align: center;
    width: 2rem;
    height: 2rem;
    border-radius: 0.25rem;
    background-color: $jps-gray-100;
    color: $jps-key-blue;

    &:hover {
      text-decoration: underline;
      background-color: $jps-gray-200;
      cursor: pointer;
    }

    &:disabled {
      pointer-events: none;
      background-color: $jps-gray-200;
      color: $jps-gray-500;
    }
    margin-left: 4px;
  }

  .page-input {
    display: flex;
    align-items: center;
    .jps-input {
      max-width: 3rem;
      padding-left: 0.25rem;
      padding-right: 0.25rem;
      font-size: 1rem;
      height: 1.25rem;
      line-height: 1.25rem;
      text-align: right;
      border-radius: 4px;
    }
    margin-right: 0.25rem;
  }
}
</style>
